import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class PreviewCount implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;
  private fUpdatedAt?: Date;

  constructor(
    private fId: string,
    private fCurrentValue: number,
    private fMaxValue: number
  ) {
    [fId, fCurrentValue, fMaxValue].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get currentValue(): number {
    return this.fCurrentValue;
  }

  get maxValue(): number {
    return this.fMaxValue;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }

  get updatedAt(): Date | undefined {
    return this.fUpdatedAt;
  }
}
